import React, { useCallback } from 'react'
import { css } from '@emotion/react'
import { useDispatch, useSelector } from 'react-redux'
import { selectWidgetFromUrl } from 'ducks/widgets/selectors/widgets'
import { Icon } from 'util/ui'
import { SUI } from 'shared/ui'
import { doShowChatAvailabilityModal } from 'actions/modals'
import { selectIsOfflineAgentsBotRunningForRoomFromUrl } from 'ducks/chat/selectors/botState'

const barStyle = () => theme => css`
  display: flex;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  padding: 10px;
  color: ${theme.color.monochrome.black};
  font-size: ${theme.fontSize.base};
`

const linkStyle = () => theme => css`
  &&& {
    color: inherit;
    text-decoration: underline;
    font-weight: ${theme.fontWeight.medium};
  }
`

const variants = {
  existing: {
    message:
      'Your live chat is currently enabled only for existing conversations.',
    style: () => theme => css`
      background-color: ${theme.color.primary.warning};
    `,
  },
  offline: {
    message:
      'Your live chat is currently disabled for new & existing conversations.',
    style: () => theme => css`
      background-color: ${theme.color.primary.negative};
      color: ${theme.color.monochrome.white};
    `,
  },
}

const botsRunningStatus = {
  message: `The "No online ${app.t(
    'agent'
  )}" bot is currently running as no ${app.t('agents')} are online.`,
  style: () => theme => css`
    background-color: ${theme.color.primary.warning};
  `,
}

const AvailabilityBar = () => {
  const widget = useSelector(selectWidgetFromUrl)
  const offlineBotRunning = useSelector(
    selectIsOfflineAgentsBotRunningForRoomFromUrl
  )
  const dispatch = useDispatch()
  const onEditVisibilityClick = useCallback(
    e => {
      dispatch(doShowChatAvailabilityModal())
      e.preventDefault()
    },
    [dispatch]
  )

  if (!widget || !widget.publishedSettings) return null
  const chatAvailability =
    widget.publishedSettings['chat.availability'] || 'online'
  if (!offlineBotRunning && chatAvailability === 'online') return null

  let status = variants[chatAvailability]
  let linkToEditVisibility = true

  if (offlineBotRunning && chatAvailability !== 'offline') {
    status = botsRunningStatus
    linkToEditVisibility = false
  }

  return (
    <SUI>
      <div css={[barStyle, status.style]}>
        <Icon name="warning sign" fitted />
        &nbsp;
        {status.message}
        &nbsp;
        {linkToEditVisibility && (
          <a css={linkStyle} href="/" onClick={onEditVisibilityClick}>
            Edit visibility
          </a>
        )}
      </div>
    </SUI>
  )
}

export default AvailabilityBar
